export default __webpack_public_path__ + "static/media/Icon-AI-Scanner-Wordmark-Meigara.22a668ae.svg";